export default __webpack_public_path__ + "static/media/nine.8f3d0ee3.png";